import { z } from 'zod';

export const basisSchema: z.ZodType = z.lazy(() => z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('package_subtotal') }),
  z.object({ kind: z.literal('sections'), sections: z.array(z.string().min(1)).min(1) }),
  z.object({ kind: z.literal('charges'), chargeIds: z.array(z.string().uuid()).min(1) }),
  z.object({ kind: z.literal('composite'), parts: z.array(basisSchema).min(2) }),
]));

export const calcMethodSchema = z.enum(['flat', 'percentage']);
export const inferenceSourceSchema = z.enum(['extracted', 'inferred', 'user-overridden', 'legacy']);
export const confidenceSchema = z.enum(['high', 'medium', 'low']);
